import {UISidebarController} from '../../../ui_html/sidebar/UISidebarController'

export class UIDRefundPolicySceneController {
    private readonly sidebarController: UISidebarController
    private readonly refundPolicySceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.refundPolicySceneContainerDiv = document.getElementById('scene_discord_refund_policy_container') as HTMLDivElement
    }

    hide() {
        this.refundPolicySceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.refundPolicySceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
